module.exports = __webpack_public_path__ + "img/revolve_logo.620006dc.svg";